import React from 'react';
import { ValidationBadge } from './ValidationBadge';

/** Explica visualmente "+9 con opción adicional +4": son dos valores distintos del mismo ítem. */
export function ItemLevelExplainer({
  level = 9,
  option = 4
}: {
  level?: number;
  option?: number;
}) {
  return <div className="rounded-2xl border border-white/10 bg-[#0A1628] p-3.5 md:p-4" data-id="element-833" data-mp="1bg1x79kj38t7">
      <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-834" data-mp="1fglse7ljk2cp">
        <p className="text-sm font-semibold text-white" data-id="element-835" data-mp="1kdkouwsogle2">¿Qué significa “+{level} con opción +{option}”?</p>
        <ValidationBadge status="clasica" data-id="element-836" data-mp="1pbvwd0vi2jt4" />
      </div>
      <div className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-837" data-mp="1u4f77q2sz0u8">
        <div className="rounded-xl border border-[#D4AF37]/30 p-3" data-id="element-838" data-mp="1u4yrhdfxe1bf">
          <p className="font-cinzel text-2xl font-black text-[#D4AF37]" data-id="element-839" data-mp="1z28g4qvhq8y7">+{level}</p>
          <p className="mt-1 text-sm font-semibold text-white" data-id="element-840" data-mp="235mvrgfionb4">Nivel del ítem</p>
          <p className="mt-0.5 text-xs text-gray-400" data-id="element-841" data-mp="283oqiymb2b2f">Aparece junto al nombre (p. ej. “Wings of Dragon +{level}”). Se sube con Jewel of Bless y Jewel of Soul.</p>
        </div>
        <div className="rounded-xl border border-sky-300/30 p-3" data-id="element-842" data-mp="16epw6so39ybi">
          <p className="font-cinzel text-2xl font-black text-sky-200" data-id="element-843" data-mp="12efqlh47l9x6">+{option}</p>
          <p className="mt-1 text-sm font-semibold text-white" data-id="element-844" data-mp="xh7454c12jq4">Opción adicional</p>
          <p className="mt-0.5 text-xs text-gray-400" data-id="element-845" data-mp="shkq4sodkzg9">Línea extra de daño, defensa o recuperación en la descripción del ítem. Se sube con Jewel of Life.</p>
        </div>
      </div>
      <p className="mt-2 text-xs text-gray-500" data-id="element-846" data-mp="1l5qahebiomfk">Un ítem +{level} sin opción adicional no cumple el requisito, ni uno con opción +{option} pero nivel menor.</p>
    </div>;
}